import { render } from "./DirectorioMember.vue?vue&type=template&id=f573df0e&scoped=true"
import script from "./DirectorioMember.vue?vue&type=script&lang=ts"
export * from "./DirectorioMember.vue?vue&type=script&lang=ts"

import "./DirectorioMember.vue?vue&type=style&index=0&id=f573df0e&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-f573df0e"

export default script